export type UserRole =
  | 'ADMIN'
  | 'GERENTE'
  | 'VENDEDOR'
  | 'OPERADOR'
  | 'ESTOQUISTA'
  | 'FINANCEIRO'
  | 'COMPRADOR';

// Rota do Dashboard centralizada para fácil alteração
export const DASHBOARD_ROUTE = '/vendas/dashboard';

export const MENU_ROLES = {
  topItems: {
    [DASHBOARD_ROUTE]: ['ADMIN', 'GERENTE'] as UserRole[],
    '/caixas': ['ADMIN', 'GERENTE'] as UserRole[],
    '/vendas': ['ADMIN', 'GERENTE', 'VENDEDOR'] as UserRole[],
    '/compras': ['ADMIN', 'GERENTE'] as UserRole[],
    '/estoque': ['ADMIN', 'GERENTE'] as UserRole[],
    '/usuarios': ['ADMIN', 'GERENTE'] as UserRole[],
    '/empresas': ['ADMIN', 'GERENTE'] as UserRole[],
    '/clientes/contas': ['ADMIN', 'GERENTE', 'FINANCEIRO', 'VENDEDOR'] as UserRole[],
  },
  cadastroItems: {
    '/produtos': ['ADMIN', 'GERENTE'] as UserRole[],
    '/categorias': ['ADMIN', 'GERENTE'] as UserRole[],
    '/marcas': ['ADMIN', 'GERENTE'] as UserRole[],
    '/embalagens': ['ADMIN', 'GERENTE'] as UserRole[],
    '/precos': ['ADMIN', 'GERENTE'] as UserRole[],
    '/fornecedores': ['ADMIN', 'GERENTE'] as UserRole[],
    '/configuracoes/tipos-pagamento': ['ADMIN', 'GERENTE'] as UserRole[],
    '/clientes': ['ADMIN', 'GERENTE', 'VENDEDOR'] as UserRole[],
  },
  reportsItems: {
    '/relatorios/vendas': ['ADMIN', 'GERENTE'] as UserRole[],
    '/relatorios/pagamentos': ['ADMIN', 'GERENTE'] as UserRole[],
    '/relatorios/estoque-movimentos': ['ADMIN', 'GERENTE', 'ESTOQUISTA'] as UserRole[],
  },
} as const;

export type MenuRolesConfig = typeof MENU_ROLES;